module.exports = __webpack_public_path__ + "static/img/icon6.dbd600a3.png";